import { render, staticRenderFns } from "./default-template.html?vue&type=template&id=61c0de9e&scoped=true&external"
import script from "./default-template.js?vue&type=script&lang=js&external"
export * from "./default-template.js?vue&type=script&lang=js&external"
import style0 from "./default-template.scss?vue&type=style&index=0&id=61c0de9e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c0de9e",
  null
  
)

export default component.exports